"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilledBody = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var Table_1 = require("../Table");
var DataTable_1 = require("./DataTable");
var TableLoadingRow_1 = require("./TableLoadingRow");
var TablePlaceholderRow_1 = require("./TablePlaceholderRow");
function TableFilledBody(props) {
    var columns = props.columns, rows = props.rows, loading = props.loading, onRowClick = props.onRowClick;
    var css = styles_1.useCss().css;
    var handleClick = function (row) { return function (e) { return onRowClick(row); }; };
    var isEmpty = function () { return !rows || rows.length === 0; };
    return (react_1.default.createElement(Table_1.TableBody, null,
        loading && react_1.default.createElement(TableLoadingRow_1.TableLoadingRow, { colSpan: columns.length }),
        !loading && isEmpty() && react_1.default.createElement(TablePlaceholderRow_1.TablePlaceholderRow, { colSpan: columns.length }),
        rows.map(function (row, idx) { return (react_1.default.createElement(Table_1.TableRow, { key: idx, onClick: onRowClick && handleClick(row) }, columns.map(function (col, colIdx) { return (react_1.default.createElement(Table_1.TableCell, { key: colIdx, style: css(DataTable_1.defaultColumnStyles(col), col.style) }, col.render(row))); }))); })));
}
exports.TableFilledBody = TableFilledBody;
//# sourceMappingURL=TableFilledBody.js.map